export const emailjsKey = "user_LLMu57ayluwNKKBGwVB4M";
// export const emailjsTemplateId = "template_F5oS1EzI";
export const emailjsServiceId = "sohoblinds";

export const emailjsTemplateIdContactUs = "sohoblinds_contact_us";
export const emailjsTemplateIdQuote = "sohoblinds_quote";
